
import { Component, Vue, Prop } from 'vue-property-decorator';
import type { HistoryItem, NotificationType, SendMode } from '../../model/types';

const TYPE_LABELS: Record<NotificationType, string> = {
  statusReport: '現況報告',
  dispatchRequest: '派遣要請',
  standbyRelease: '待機解除',
};

const MODE_LABELS: Record<SendMode, string> = {
  manual: '手動送信済',
  auto: '自動送信済',
};

@Component
export default class SendHistory extends Vue {
  @Prop({ default: () => [] }) readonly items!: HistoryItem[];

  formatSentAt(iso: string): string {
    const date = new Date(iso);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1);
    const day = String(date.getDate());
    const hour = String(date.getHours()).padStart(2, '0');
    const minute = String(date.getMinutes()).padStart(2, '0');
    return `${year}年${month}月${day}日 ${hour}:${minute}`;
  }

  typeLabel(type: NotificationType): string {
    return TYPE_LABELS[type] ?? type;
  }

  modeLabel(mode: SendMode): string {
    return MODE_LABELS[mode] ?? mode;
  }
}
